import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
//Redux
import { useSelector, useDispatch } from "react-redux";
import Constants from "../../../common/SupplierConstants";
import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";
import {
  getDelegationList,
} from "../../../redux/feature/supplier_app/sourcingSlice";
import { SearchField } from "../../../Components/formElements/SearchField";
import { formatDate } from "../../../common/Validations";
import StickyColumn from "../../../Components/Sticky/StickyColumn";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import ItemService from "../../../services/supplier_appCommonService";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
import Layout from "../../../Layout/Layout";
import DelegationModal from "./DelegationModal";
import DelegationUpdateModal from "./DelegationUpdateModal";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";

const DelegationList = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Delegation");
  localStorage.setItem("submenu", "Task Delegation");
  let quotationData = useSelector((state) => state?.sourcing?.delegation); // User Details from Store
  let quotationTable = useSelector(
    (state) => state?.sourcing.delegation.pagination,
  ); // User Details from Store

  // eslint-disable-next-line
  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [showStats, setShowStats] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [delegationModal, setDelegationModal] = useState();
  const[updateModal, setUpdateModal] = useState(false);

  const showDelegationModal = () => setDelegationModal(true);
  const hideModal = () => setDelegationModal(false);

  const hideUpdateModal = () => setUpdateModal(false);  
  const [selectedRow, setSelectedRow] = useState(null);
  useEffect(() => {
    if (!showStats) {
      setFilteredData(quotationData?.data || []);
    }
  }, [showStats, quotationData]);
  const [filterShow, setFilterShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

const handleEditClick = (row) => {
  setSelectedRow(row);
  setUpdateModal(true);
};
  useEffect(() => {
    let obj = {
      queryName: "DelegationList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getDelegationList(obj));
    setData(quotationData?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "DelegationList",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getDelegationList(obj));
    setData(quotationData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "DelegationList",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getDelegationList(obj));
    setData(quotationData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "DelegationList",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getDelegationList(obj));
  };
  const columns = [
    {
      name: "Delegation Nr",
      selector: (row) => row.documentNumber || "--",
      id: "documentNumber",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPage(row.documentNumber, row.qtnVersion)}
        onClick={() => handleEditClick(row)}
        >
          {row.documentNumber || "-"}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Form User",
      selector: (row) => row.formUser,
      sortable: true,
      width: "120px",
    },
    {
      name: "To User",
      selector: (row) => row.toUser,
      sortable: true,
      width: "120px",
    },
    {
      name: "Form Date",
      selector: (row) => formatDate(row.formDate),
      sortable: true,
      width: "190px",
    },
    {
      name: "To Date",
      selector: (row) => formatDate(row.toDate),
      sortable: true,
      width: "190px",
    },
      {
          name: "Action",
          cell: (row) => (
            <TableActions
              actions={[
            
                {
                  label: "Edit",
                  icon: "bi bi-pencil-square",
                  iconClass: "text-success",
                  bg: "#e6f7ee",
                  onClick: () => handleEditClick(row),
                },
                {
                  label: "Delete",
                  icon: "bi bi-trash",
                  iconClass: "text-danger",
                  bg: "#fdeaea",
                  // onClick: () => deleteQuotaionJob(row),
                },
                {
                  label: "More",
                  icon: "bi bi-three-dots",
                  bg: "#f1f3f5",
                  onClick: () => console.log("More", row),
                },
              ]}
            />
          ),
          width: "180px",
        },
  ];
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "DelegationList",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getDelegationList(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Delegation List</h2>
                <p className="subText">Lists of Delegation and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                // data={data}

                fetchFunction={ItemService.getDelegationList}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <hr />

            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.getQuotation}
                  keyName="rfxHeaderStatus"
                  paginatedList={quotationData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                />
              </div>
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DL</span>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                      <span className="headerTitle">Delegation List</span>
                      <span className="subHeaderTitle">
                        View of Delegation and Status
                      </span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col
                        xs={4}
                        md={2}
                        lg={2}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={showDelegationModal}
                        >
                          <i className="bi bi-plus-lg"></i> Create Delegation
                        </button>
                      </Col>
                    </Col>
                    {/* <Col xs={4} md={4} lg={4}>
                      <button
                        onClick={() => setShowStats(!showStats)}
                        className="p-1 bg-transparent border-0 cursor-pointer"
                      >
                        <ChartBarIcon className="w-7 h-7 text-blue-500" />
                      </button>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3, 4]}
                        leftOffsets={[0, 140, 240]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={filteredData}
                          progressPending={quotationData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={quotationTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DelegationModal
        show={delegationModal}
        onHide={hideModal}
      />
      <DelegationUpdateModal
        show={updateModal}
        onHide={hideUpdateModal}
          editData={selectedRow}
      />
    </main>
  );
};

export default DelegationList;
